<template>
  <div id="app">
    <center>
      <div id="header">
        <img id="logo" src="./assets/logo.png">
        <img id="objetos" src="./assets/objetos.png">
      </div>

      <div id="leyenda">
        <p>Para tu casa o para regalar, <br> a tu gusto y a la medida de tus necesidades.</p>
      </div>
    </center>

    <breadcrumb></breadcrumb>
    <transition name="component-fade" mode="out-in">
      <router-view id="view" :key="$route.path"></router-view>
    </transition>
    <hr>

    <div class='footer'>

      <a class="fb"
         href="https://www.facebook.com/pages/ML-Objetos-de-Tela/970222089668822">
         <img src="./assets/fb.png">
       </a>
      <a class="ig" href="https://www.instagram.com/mlobjetosdetela/">
        <img src="./assets/ig.png">
      </a>
      <a class="mail"
         href="mailto:mlobjetosdetela@gmail.com">
         <img src="./assets/mail.png">
       </a>

      <a class="qrafip" href="http://qr.afip.gob.ar/?qr=Z2iSEl-daCr73ps31_ktlw,,"
          target="_F960AFIPInfo">
        <img src="./assets/qrafip.jpg" border="0"/>
      </a>

      <div style='clear: both;'></div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from './components/Breadcrumb'

export default {
  name: 'App',
  components: {Breadcrumb}
}
</script>

<style>
body {
    background: url('./assets/fondo.png');
    font-family: Verdana, sans-serif;
}

#app {
  background: white; width: 600px;
  border: 5px white solid;
  margin: 0 auto;
}

#header {
    border: 3px dashed #F2C8CC;
    padding: 3px;
    margin-bottom: 3px;
}
#objetos { margin: 30px 20px;}

div#leyenda {
  margin: 2em 0;
}

#view {
  min-height: 20em;
}

.component-fade-enter-active, .component-fade-leave-active {
  transition: opacity .3s ease;
}
.component-fade-enter, .component-fade-leave-to {
  opacity: 0;
}

.footer {
  margin: 0 10px;
}
.footer img {
  height: 40px;
  margin: 13px;
}

.footer .qrafip img {
  height: 46px;
  margin: 10px;
}

.fb, .ig, .mail {
  float: left;
}

.fb, .ig, .mail {
  opacity: 0.5;
}

.fb:hover, .ig:hover, .mail:hover {
  opacity: 1;
}

.qrafip {
  float: right;
}

.epa {
  text-align: center;
}
.epa div {
  display: inline-block;
  background-color: #fcb88c;
  padding: 2em;
  border-radius: 2em;
}

a {
  color: #444;
  text-decoration: none;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 0.2em;
  padding: 0.1em;
  outline: 0;
}

a:hover, a:active, a:focus {
  color: #222;
  text-decoration: none;
}

hr {
    display: block;
    height: 1px;
    border: 0;
    border-top: 2px solid #F2C8CC;
    margin: 1em 0;
    padding: 0;
}

</style>



// WEBPACK FOOTER //
// src/App.vue